import { EPersonalVerifyKey } from '../enums/personal-verification.enum';
import { OptionDescription } from './option.type';

export type PersonalVerificationFieldRecord = Record<EPersonalVerifyKey, OptionDescription<EPersonalVerifyKey>>;
